import { Link } from 'react-router-dom';
import {
  NavBar as ProximaNavBar,
  NavBarButton,
  ProximaLogo,
  NavbarMenu,
} from '@innovationdepartment/proxima-ui';

import { useUserStore } from 'stores';
import { IUser } from '@innovationdepartment/proxima-ui/dist/esm/types/user';
import { PropsOf } from '@emotion/react';

const logo = (
  <Link to="/brands">
    <ProximaLogo />
  </Link>
);

type DrawerButtonType = {
  button: {
    icon: JSX.Element;
    label: string;
  };
  isActive: boolean;
  drawerItems: {
    items: {
      items: {
        label: string;
        pathname: string;
      }[];
      label: string;
    }[];
    onClick: (pathname: string) => void;
    title: string;
  };
  label?: undefined;
  pathname?: undefined;
  icon?: undefined;
};

type NavBarViewProps = {
  accountMenuItems: {
    label: string;
    onClick: () => void;
    pathname: string;
    trailingDivider?: boolean;
  }[];
  navbarTopButtons: (
    | {
        label: string;
        pathname: string;
        icon: JSX.Element;
        button?: undefined;
        isActive?: undefined;
        drawerItems?: undefined;
      }
    | DrawerButtonType
  )[];
  navbarBottomButtons: PropsOf<typeof NavbarMenu>[];
};

const NavBarView = (props: NavBarViewProps) => {
  const { accountMenuItems, navbarTopButtons, navbarBottomButtons } = props;
  const { user } = useUserStore();

  const isButtonActive = (buttonPathname: string) => window.location.pathname === buttonPathname;

  return (
    <ProximaNavBar
      logo={logo}
      accountMenuItems={accountMenuItems}
      pathname={window.location.pathname}
      user={user as IUser}
      navbarMenuItems={navbarBottomButtons}
    >
      {navbarTopButtons.map((button) => {
        const hasDrawer = button.button;

        if (hasDrawer)
          return (
            <NavBarButton
              button={button.button}
              isActive={button.isActive}
              key={button.button.label}
              drawerItems={button.drawerItems}
            />
          );

        const isActive = isButtonActive(button.pathname);

        return (
          <Link to={button.pathname} key={button.label}>
            <NavBarButton button={button} isActive={isActive} />
          </Link>
        );
      })}
    </ProximaNavBar>
  );
};

export default NavBarView;
